import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { motion } from "framer-motion";

const Avatar = () => {
  const container = useRef();
  const imgRef = useRef();

  useGSAP(() => {
    gsap.fromTo(imgRef.current, 
      { 
        clipPath: "inset(50% 0% 50% 0%)",
        scale: 1.2
      },
      {
        clipPath: "inset(0% 0% 0% 0%)",
        scale: 1,
        duration: 2,
        ease: "power4.inOut",
        scrollTrigger: {
          trigger: container.current,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      }
    );

    gsap.from(".text-section", {
      x: -100,
      opacity: 0,
      duration: 1,
      stagger: 0.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: container.current,
        start: "top 70%",
        toggleActions: "play none none reverse"
      }
    });
  }, { scope: container });

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (custom) => ({
      opacity: 1,
      x: 0,
      color: "rgb(6 213 246)",
      transition: {
        delay: custom * 0.3,
        duration: 0.7,
      },
    }),
  };

  return (
    <div ref={container} className="flex flex-col lg:flex-row justify-center items-center lg:gap-20 gap-10 lg:p-20 p-5 relative lg:left-[-150px] min-h-screen overflow-hidden">
      <div className="lg:w-[60%] w-full rounded-2xl md:rounded-r-3xl overflow-hidden shadow-2xl">
        <img
          ref={imgRef}
          src="/Avatar-ai.png"
          alt="avatar-ai"
          className="object-cover h-full w-full transform hover:scale-105 transition-transform duration-700"
        />
      </div>
      <div>
        <h1 className=" md:text-3xl text-2xl mt-5 font-semibold">
          How it works
        </h1>
        <motion.p
          custom={0}
          initial="hidden"
          whileInView="visible"
          variants={textVariants}
          className="text-section lg:text-4xl text-2xl lg:mt-10 mt-6"
        >
          Select an Avatar
        </motion.p>
        <motion.p
          custom={1}
          initial="hidden"
          whileInView="visible"
          variants={textVariants}
          className="text-section lg:text-4xl text-2xl mt-4"
        >
          Create or Generate Script
        </motion.p>
        <motion.p
          custom={2}
          initial="hidden"
          whileInView="visible"
          variants={textVariants}
          className="text-section lg:text-4xl text-2xl mt-4"
        >
          Select AI Voices
        </motion.p>
        <motion.p
          custom={3}
          initial="hidden"
          whileInView="visible"
          variants={textVariants}
          className="lg:text-4xl text-2xl mt-4"
        >
          Piblish
        </motion.p>
      </div>
    </div>
  );
};

export default Avatar;
